var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9258 0H13.1719V2.22656H15.2422V0H17.4883V6.73828H15.2422V4.49219H13.1914V6.73828H10.9258M20.457 2.24609H18.4746V0H24.6953V2.24609H22.7031V6.73828H20.457M25.6816 0H28.0352L29.4805 2.37305L30.9258 0H33.2793V6.73828H31.0332V3.39844L29.4609 5.82031L27.8887 3.39844V6.73828H25.6816M34.3926 0H36.6387V4.51172H39.8223V6.73828H34.3926",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8477 45.9961L7.625 9.82422H43.0547L39.832 45.9766L25.3105 50",
    fill: "#E44D26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3398 46.9238V12.793H39.8223L37.0586 43.6523",
    fill: "#F16529"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.207 17.2168H25.3398V21.6504H19.0703L19.4805 26.1914H25.3398V30.6152H15.418M15.6133 32.8418H20.0664L20.3789 36.3867L25.3398 37.7148V42.3437L16.2383 39.8047",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4336 17.2168H25.3203V21.6504H36.0234M35.623 26.1914H25.3203V30.625H30.7891L30.2715 36.3867L25.3203 37.7148V42.3242L34.4023 39.8047",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.ea429fa52e26546786c91cbd628ef5a2.svg";
export { ForwardRef as ReactComponent };